import { Mail, Phone, User, UserCircle } from 'lucide-react';
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/Card';
import { Input } from './ui/Input';

// requireContact: phone and gender are mandatory (the tenant wizard — UM stores both NOT NULL).
export function NewUserForm({ formData, setFormData, errors = {}, requireContact = false }) {
    return (
        <Card className="border-primary-100 bg-primary-50/30">
            <CardHeader>
                <CardTitle className="text-base flex items-center gap-2">
                    <UserCircle className="h-5 w-5 text-primary-600" />
                    New User Information
                </CardTitle>
                <CardDescription>Enter details for the new admin user</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">
                            Username <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                            <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400" />
                            <Input
                                type="text"
                                required
                                value={formData.username || ''}
                                onChange={(e) => setFormData({ ...formData, username: e.target.value.toLowerCase() })}
                                placeholder="admin@example.com"
                                className="pl-9"
                            />
                        </div>
                        {errors.username && <p className="text-xs text-red-600 mt-1">{errors.username}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">
                            Email <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400" />
                            <Input
                                type="email"
                                required
                                value={formData.email_id || ''}
                                onChange={(e) => setFormData({ ...formData, email_id: e.target.value.toLowerCase() })}
                                placeholder="user@example.com"
                                className="pl-9"
                            />
                        </div>
                        {errors.email_id && <p className="text-xs text-red-600 mt-1">{errors.email_id}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">
                            First Name <span className="text-red-500">*</span>
                        </label>
                        <Input
                            type="text"
                            required
                            value={formData.first_name || ''}
                            onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                            placeholder="John"
                        />
                        {errors.first_name && <p className="text-xs text-red-600 mt-1">{errors.first_name}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">
                            Last Name <span className="text-red-500">*</span>
                        </label>
                        <Input
                            type="text"
                            required
                            value={formData.last_name || ''}
                            onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                            placeholder="Doe"
                        />
                        {errors.last_name && <p className="text-xs text-red-600 mt-1">{errors.last_name}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">
                            Phone Number {requireContact && <span className="text-red-500">*</span>}
                        </label>
                        <div className="relative">
                            <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400" />
                            <Input
                                type="tel"
                                required={requireContact}
                                value={formData.phone_no || ''}
                                onChange={(e) => setFormData({ ...formData, phone_no: e.target.value })}
                                placeholder="+1234567890"
                                className="pl-9"
                            />
                        </div>
                        {errors.phone_no && <p className="text-xs text-red-600 mt-1">{errors.phone_no}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">
                            Gender {requireContact && <span className="text-red-500">*</span>}
                        </label>
                        <select
                            required={requireContact}
                            value={formData.gender || ''}
                            onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                            className="flex h-9 w-full rounded-md border border-slate-200 bg-white px-3 py-1 text-sm shadow-sm transition-colors outline-none focus-visible:border-primary-500 focus-visible:ring-primary-200 focus-visible:ring-2"
                        >
                            <option value="">Select gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                        </select>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
